import { StorageManager } from "./storage";

let sessionStorageInstance: StorageManager | null = null;

if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
  sessionStorageInstance = new StorageManager(localStorage);
}

export const SessionStorage = sessionStorageInstance;
